import type { FC, MouseEventHandler, Ref } from 'react';
import { getAccessibleTabIndex } from '../Button/ariaHelpers';
import { Icon } from '../Icon/Icon';
import { getBookmarkClassNames } from './Bookmark.styles';

export type BookmarkProps = {
  className?: string;
  disabled?: boolean;
  forwardRef?: Ref<HTMLButtonElement>;
  loading?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  selected: boolean;
};

export const Bookmark: FC<BookmarkProps> = (props) => {
  const bookmarkDisabled = props.loading || props.disabled;
  return (
    <button
      ref={props.forwardRef}
      className={getBookmarkClassNames(
        props.className,
        bookmarkDisabled,
        props.selected,
      )}
      disabled={bookmarkDisabled}
      onClick={props.onClick}
      type='button'
      tabIndex={getAccessibleTabIndex(bookmarkDisabled)}
    >
      <Icon
        glyph='fa-bookmark'
        iconStyle='solid'
        loading={props.loading}
        size='sm'
      />
    </button>
  );
};
